import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Icon } from '@material-ui/core';
import PropTypes from 'prop-types';

import apiService from '../../services.js/apiService';
import { IsEmpty } from '../../common/checks';
import MText from '../common/MText';
import { Status } from '../../common/constants';

const PoiHeader = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [poi, setPoi] = useState(null);

  const getPoi = async (id) => {
    try {
      setIsLoading(true);
      const data = await apiService.getPoi(id);
      setPoi(data);

      if (IsEmpty(data)) {
        toast.warn('Poi not found');
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!IsEmpty(props.id)) {
      getPoi(props.id);
    } else {
      setPoi(null);
    }
  }, [props.id]);

  return (
    <div className="d-flex flex-row justify-content-start align-items-center content-header pt-3 pb-2">
      <Link to="/admin/pois" title="Back to list" className="d-flex align-items-center">
        <Icon className="back">arrow_back</Icon>
      </Link>

      { !isLoading && <MText size={22} text={poi ? poi.name : 'Add POI'} /> }

      {
        (!IsEmpty(poi) && poi.status === Status.Deactivated) && (
          <MText className="ml-2" text={`(${Status.Deactivated})`} size={20} />
        )
      }
    </div>
  );
};

PoiHeader.propTypes = {
  id: PropTypes.number.isRequired,
};

export default PoiHeader;
